export const HOST = process.env.HOST || '0.0.0.0';
export const STATIC_ASSETS_CACHE_TIME_IN_SECONDS = 31536000;
export const PORT = process.env.PORT || 3000;
export const DISPLAY_ACCESS_LOGS = process.env.DISPLAY_ACCESS_LOGS !== 'false';
export const ASSET_PATH = process.env.ASSET_PATH || '/sitemap/public/';
